import React, { useMemo } from 'react'

import cx from 'classnames'
import { pluralize } from 'humanize-plus'
import { isEmpty, isNil } from 'ramda'

import { Div, H3 } from '@driftt/tide-core'

import ChartLoader from 'components/core/ChartLoader'
import { getHumanizedShortDuration, TypeFormats } from 'utils/format'

import './style.css'

interface ITotalCountChartProps {
  title: string
  loading?: boolean
  data?: any
}

const ChartBody = ({ title, data }: ITotalCountChartProps) => {
  const isTimeCount = useMemo(
    () => data && !Array.isArray(data) && data.time,
    [data]
  )

  const totalCount = useMemo(() => {
    if (isTimeCount) {
      return getHumanizedShortDuration(data.time)
    } else if (Array.isArray(data)) {
      return TypeFormats.RAW_HUMANIZED(data[data.length - 1][1])
    }

    return '0'
  }, [data, isTimeCount])

  const totalCountValue = useMemo(() => {
    if (isTimeCount) {
      return data.time
    } else if (Array.isArray(data)) {
      return data[data.length - 1][1]
    }
    return 0
  }, [data, isTimeCount])

  return (
    <Div className={cx('total-count-count-container', 'inline')}>
      <H3 className="total-count-count">
        {totalCount} {pluralize(totalCountValue, title, `${title}s`)}
      </H3>
    </Div>
  )
}

const TotalCountChart = (props: ITotalCountChartProps) => {
  if (props.loading) {
    return <ChartLoader />
  }

  if (isNil(props.data) || isEmpty(props.data)) {
    return null
  }

  return (
    <Div className="chart-container-body">
      <ChartBody {...props} />
    </Div>
  )
}

export default TotalCountChart
